import React from "react";
import { BrowserRouter as Router, Link } from "react-router-dom";
import scrollTo from "../helpers/scroll-to";
import images from "../assets/images";
import Header from "../components/Header";
import Nav from "../components/Nav";
import MobileNav from "../components/MobileNav";
import Footer from '../components/Footer';
import jQuery from 'jquery';
// import Adobe from "../components/Adobe";

import { Posts } from '../helpers/wp-api';
const postsFeedApi = new Posts('https://content.paodeacucar.com/wp-json/wp/v2');

const TEMPLATE_NAME = "gpa-default";
const links = [
  {
    desc: "Sustentabilidade no Pão",
    hash: "#sustentabilidade-no-pao",
    href: "/",
    top: 30
  },
  {
    desc: "Conceito",
    hash: "#conceito",
    href: "/conceito"
  },
  {
    desc: "Nossas Iniciativas",
    hash: "#nossas-iniciativas",
    href: "/nossas-iniciativas"
  },
  {
    desc: "Cadastre-se",
    hash: "#cadastre-se",
    href: "/cadastre-se",
    class: 'optin'
  },
]
const links_top = [
  {
    desc: process.env.BRAND_INITIALS === "pa" ? "Pão de Açúcar" : " Delivery Extra",
    href: process.env.BRAND_INITIALS === "pa" ? "https://www.paodeacucar.com/" : "https://www.deliveryextra.com/",
    target: '_blank'
  },
  {
    desc: process.env.BRAND_INITIALS === "pa" ? "Cartões Pão de Açúcar" : "Cartões Extra",
    href: process.env.BRAND_INITIALS === "pa" ? "https://www.paodeacucar.com/cartoes" : "https://www.deliveryextra.com/cartoes",
    target: '_blank'
  },
  {
    desc: "Fale Conosco",
    href: "http://faleconosco.grupopaodeacucar.com.br/pdamais/home/faleconosco",
    target: '_blank'
  },
  {
    desc: "Nossas Lojas",
    href: "http://www.grupopaodeacucar.com.br/gmaps/busca.aspx?q=delivery",
    target: '_blank'
  },
  {
    desc: "Cliente Mais",
    href: "http://www.paodeacucar.com/mais",
    target: '_blank'
  },
]
const mob_links = [
  {
    desc: "Sustentabilidade no Pão",
    hash: "#sustentabilidade-no-pao",
    href: "/",
    top: 30
  },
  {
    desc: "Conceito",
    hash: "#conceito",
    href: "/conceito"
  },
  {
    desc: "Nossas Iniciativas",
    hash: "#nossas-iniciativas",
    href: "/nossas-iniciativas"
  },
  {
    desc: "Cadastre-se",
    hash: "#cadastre-se",
    href: "/cadastre-se",
    class: 'optin'
  },
]
export default class Default extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileMenu: false,
      firstPost: {},
      postsList: [],
      flipped: {}
    };
    this.flipContainer = this.flipContainer.bind(this);
  }

  componentDidMount() {
    this.animatedScroll();
  }

  componentWillMount() {
    postsFeedApi.list({ _embed: true, per_page: 4, categories: 30 })
      .then(response => response.json())
      .then(posts => {
          return posts.map(post => ({
              thumbnail: post._embedded['wp:featuredmedia'][0].media_details.sizes.thumbnail.source_url,
              img_big: post._embedded['wp:featuredmedia'][0].media_details.sizes.big.source_url,
              title: post.title.rendered,
              link: post.link+"?utm_source=SiteSustentabilidade&utm_medium=Hub&utm_term=UltimasNovidades",
              rendered: post.excerpt.rendered
                  .replace('<a', '<a target="_blank" ')
                  .replace(/href="(.*?)"/, 'href="$1?utm_source=SiteSustentabilidade&utm_medium=Hub&utm_term=UltimasNovidades"')
                  .replace('"more-link"', '"more-link text-primary"'),
              // url: (post.link.indexOf('utm_term') === -1)
              //     ? post.link
              //     : post.link + '?utm_source=SitePDA&utm_medium=referral&utm_term=novidades'
          }));
      })
      .then(posts => {
        this.setState({
          firstPost: posts[0],
          postsList: posts.splice(1)
        });
      });
  }

  animatedScroll = () => {
    setTimeout(() => {
      const hasRegistered = window.location.href.indexOf('?origin=register') > -1;
      if(hasRegistered){
        const el = document.querySelector("#baixe-o-app");
        var top = el.offsetTop - document.querySelector('header nav').offsetHeight;
        scrollTo("#baixe-o-app", 250)();
      }else{
        var url = window.location.pathname.replace("/sustentabilidade/", "");
        if(url.length > 0){
          const value = window.innerWidth < 768 && url == "baixe-o-app" ? 0 : 60;
          let sub = url == "sobre-o-programa" ? 30 : url == "baixe-o-app" ? value : 0;
          scrollTo("#"+url, sub)();
        }
      }
    }, 2000);
  }

  _handleBodyOverflow = (value) => {
    document.getElementsByTagName('body')[0].style.overflow = value;
  }

  _handleMobileStyle = () => {
    return this.state.mobileMenu
      ? {
        position: "absolute",
        zIndex: 1,
        }
      : {}
  }

  _handleHeaderStyle = () => {
    return this.state.mobileMenu
      ? {
        height: "100vh",
        backgroundColor: 'rgba(0,0,0, 0.5)',
        }
      : {}
  }

  flipContainer(index) {
    const isFlipped = this.state.flipped[index] && this.state.flipped[index];
    const flipped = { ...this.state.flipped[index], ...{ [index]: !isFlipped } };
    this.setState({ flipped });
  }

  optInSubmit(e) {
    e.preventDefault();

    const form = e.target;
    const email = form.email.value;

    this.setState({ optinValidation: '' });

    if (!email) {
      this.setState({ optinValidation: 'Informe o e-mail corretamente' })
      return false;
    }

    const data = {
      "receivername": email,
      "receivermail": email,
      "subject": "Sustentabilidade - Cadastro",
      "sendername": "Pão de Açúcar",
      "sendermail": "paodeacucar@news.paodeacucar.com.br",
      // "listName": "Sustentabilidade",
      // "fields": "nm_email;nome_completo;cidade;optin",
      // "values": "E-MAIL;NOME;CIDADE;1"
      "listName": "sustentabilidade",
      fields: 'nm_email',
      "values": email,
      html: '<html><body>Olá, ##nome##, seu cadastro foi efetuado com sucesso</body></html>'
    };

    // let myHeaders = new Headers();
    // myHeaders.append("Content-Type", "application/json;charset=UTF-8");
    //
    // fetch('https://midiasdigitais.gpa.digital/api/mail/subscriber/subscribe/v1.2', {
    //   method: 'POST',
    //   mode: 'cors',
    //   headers: myHeaders,
    //   body: JSON.stringify(data)
    // })
    jQuery.ajax({
      type: 'POST',
      dataType: 'json',
      url: 'https://midiasdigitais.gpa.digital/api/mail/subscriber/subscribe/v1.2',
      // contentType: "application/json",
      data
    })
        .then((data) => {
          console.log(data);
          this.setState({ optinSuccess: /Envio inserido com sucesso/i.test(data) ? 'success' : 'error' });
        })
        .catch((err) => {
          console.log(err);
          this.setState({ optinSuccess: 'error' });
        })
  }

  //TODO: make this more simple, concise and universal.
  render() {
    console.log(jQuery);
    return (
      <Router basename={process.env.BASE_URL}>
        <div className={TEMPLATE_NAME}>
          <Header style={{...this._handleHeaderStyle}}>
            <Nav
              {...this.props}
              style={this.state.mobileMenu ? { zIndex: -1 } : {}}
              onMobile={() => {
                this._handleBodyOverflow('hidden');
                this.setState({ mobileMenu: true });
                document.querySelector('.gpa-default > div').style.opacity = 0;
              }}
              logo={images.logo.logo_topo}
              links={links}
              linksTop={links_top} />
            {this.state.mobileMenu
              ? <MobileNav
                  {...this.props}
                  style={this._handleMobileStyle()}
                  onClose={(prop) => {
                  this._handleBodyOverflow(prop || 'auto');
                  this.setState({ mobileMenu: false });
                  document.querySelector('.gpa-default > div').style.opacity = 1;
                }}
                links={mob_links} />
              : null
            }
          </Header>

          {/* {React.cloneElement(this.props.children, { style: this.state.mobileMenu ? { zIndex: -1 } : {} })} */}

          <div className="sustentabilidade mb-0">
            <div className="container-fluid">
              {/* <!-- top --> */}
              <div id="sustentabilidade-no-pao">
                <div className="container">
                  <div className="row">
                    <div className="col-md-6 text-center">
                      <img className="pb-3 img-responsive"  src={images.sustentabilidade.img1} />
                    </div>
                    <div className="col-md-6">
                      <div className="text-center mb-4">
                        <img className="img-responsive"  src={images.logo.logo_sustentabilidade} />
                      </div>
                      <p className="mb-2 line-1-lg text-justify">A marca Pão de Açúcar busca inspirar, incentivar e oferecer meios para que possamos ter felicidade de maneira simples, real e ao alcance de todos, baseada especialmente nos relacionamentos com as pessoas e ambiente em que vivemos. Um de nossos pilares é o EQUILÍBRO, que representa a importância de todos nós convivermos(as) juntos(as) em busca de uma vida melhor.</p>
                      <p className="mb-2 line-1-lg text-justify">Por isso, o Pão de Açúcar tem a sustentabilidade como parte estratégica e de valor de seu negócio. Estamos sempre buscando promover conceitos de vida saudável e de inovação no varejo.</p>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12">
                      <h5 className="mb-3">Em nossas lojas, você encontra:</h5>
                      <ul className="list-unstyled">
                        <li className="mb-2">
                          <i className="text-primary font-14 mr-2 material-icons">done</i>
                          Produtos mais saudáveis e sustentáveis - muitos em espaço diferenciado - que respeitam o meio ambiente, as pessoas e o bem estar animal;
                        </li>
                        <li className="mb-2">
                          <i className="text-primary font-14 mr-2 material-icons">done</i>
                          Iniciativas que minimizam impacto ambiental negativo, pois estamos sempre buscando melhorar a relação com o ambiente e a sociedade em que vivemos;
                        </li>
                        <li className="mb-2">
                          <i className="text-primary font-14 mr-2 material-icons">done</i>
                          Ações de transformação social que fortalecem a cadeia produtiva da alimentação saudável e sustentável, fomentando e apoiando produtores e produtos in natura e minimamente processados;
                        </li>
                        <li className="mb-2">
                          <i className="text-primary font-14 mr-2 material-icons">done</i>
                          Respeito à diversidade, combatendo todas as formas de discriminação e preconceitos.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- /top --> */}

              {/* <!-- Conceito --> */}
              <div id="conceito" className="pt-4">
                <div className="container">
                  <div className="col-md-12 pb-3 mt-3 text-center">
                    <img className="mb-4" src={images.sustentabilidade.conceito} />
                    {/* <p className="mt-3">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p> */}
                  </div>
                  <div className="col-md-12 pb-3">
                    <div className="row">
                      <div className="pb-3 col-md-3 col-sm-6 col-xs-6 text-center">
                        <div className="cursor-pointer" onClick={this.props.actionsModal('open', 'ImpactoAmbiental')}>
                          <div className="card-concept-icon">
                            <img src={images.sustentabilidade.icone1} />
                          </div>
                          <p className="card-concept-text pt-4">Atitudes que minimizam o impacto ambiental</p>
                        </div>
                      </div>
                      <div className="pb-3 col-md-3 col-sm-6 col-xs-6 text-center">
                        <div className="cursor-pointer" onClick={this.props.actionsModal('open', 'ProdutosMaisSustentaveis')}>
                          <div className="card-concept-icon">
                            <img src={images.sustentabilidade.icone2} />
                          </div>
                          <p className="card-concept-text pt-4">Produtos mais Sustentáveis</p>
                        </div>
                      </div>
                      <div className="pb-3 col-md-3 col-sm-6 col-xs-6 text-center">
                        <div className="cursor-pointer" onClick={this.props.actionsModal('open', 'Diversidade')}>
                          <div className="card-concept-icon">
                            <img src={images.sustentabilidade.icone3} />
                          </div>
                          <p className="card-concept-text pt-4">Diversidade</p>
                        </div>
                      </div>
                      <div className="pb-3 col-md-3 col-sm-6 col-xs-6 text-center">
                        <div className="cursor-pointer" onClick={this.props.actionsModal('open', 'TransformacaoSocial')}>
                          <div className="card-concept-icon">
                            <img src={images.sustentabilidade.icone4} />
                          </div>
                          <p className="card-concept-text pt-4">Iniciativas de transformação social</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- /Conceito --> */}

              {/* <!-- Nossas Iniciativas --> */}
              <div id="nossas-iniciativas" className="pt-4 section-silver">
                <div className="container">
                  <div className="row">
                    <div className="col-md-12 mb-1 mt-4 text-center">
                      <img className="mb-4" src={images.sustentabilidade.iniciativas} />
                      {/* <p className="mb-4 mt-3">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p> */}
                    </div>
                    <div className="col-md-6 pb-3">
                      <div className="text-center">
                        <a href={this.state.firstPost.link} target="_blank">
                          <img className="wide img-responsive" src={this.state.firstPost.img_big} />
                        </a>
                      </div>
                      <a href={this.state.firstPost.link} target="_blank">
                        <h4 className="pt-3 news-title text-grey">{this.state.firstPost.title}</h4>
                      </a>
                      <div className="pb-3">
                        <a href={this.state.firstPost.link} target="_blank">
                          <span className="font-12 text-grey" dangerouslySetInnerHTML={{__html: this.state.firstPost.rendered}} />
                        </a>
                      </div>
                    </div>
                    <div className="col-md-6 pb-3">
                      {this.state.postsList.map((item) =>
                        <div className="media">
                          <a href={item.link} target="_blank">
                            <img className="mr-3 media-object media-middle" style={{width:'64px'}} src={item.thumbnail} />
                          </a>
                          <div className="media-body">
                            <a href={item.link} target="_blank">
                              <h4 className="mt-0 news-title text-grey">{item.title}</h4>
                              <span className="font-12 text-grey" dangerouslySetInnerHTML={{__html: item.rendered}} />
                            </a>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- /Nossas Iniciativas --> */}

              {/* <!-- Optin --> */}
              <div id="cadastre-se" className="pt-5 pb-30 section-dark-silver">
                <div className="container">
                  <div className="col-md-12 mb-1 font-12 text-center">
                    <h4>Cadastre-se</h4>
                    <p className={this.state.optinSuccess ==='success' ? 'text-success': 'text-danger' }>
                      {this.state.optinSuccess === 'success' && 'E-mail cadastrado com sucesso!'}
                      {this.state.optinSuccess === 'error' && 'Erro cadastrando e-mail, tente novamente mais tarde.'}
                    </p>
                    <p className="text-danger">
                      {this.state.optinValidation}
                    </p>
                    {/* <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p> */}
                  </div>
                  <div className="row pb-3 text-center">
                    <form name="formOptin" style={{ 'justifyContent': 'center' }} onSubmit={this.optInSubmit.bind(this)} className="form-inline offset-sm-3 col-sm-6" noValidate>
                      <div className="form-group mx-sm-3 mb-2">
                        <input name="email" type="email" style={{ background: 'white' }} className="w-340 form-control" placeholder="E-mail" />
                      </div>
                      <button style={{color:'white'}} className="btn btn-primary mb-2" type="submit">Enviar</button>
                    </form>
                  </div>
                </div>
              </div>
              {/* <!-- /Optin --> */}
            </div>
          </div>

          <Footer images={images} {...this.props}/>
        </div>
      </Router>
    );
  }
}



// WEBPACK FOOTER //
// ./src/templates/Default.js